import { inventoryApi } from '@/lib/api';
import type { Application } from '@/types';

export const fetchApplications = () => {
  return inventoryApi.get<Application[]>('/applications');
};
